// extracted by mini-css-extract-plugin
module.exports = {"container":"SamplePage_container__PJ3XW","chart":"SamplePage_chart__3Bezb","faqBorder":"SamplePage_faqBorder__GUEQ8","bannerWrapper":"SamplePage_bannerWrapper__3gYur"};